import instance from "@/services/api";

export const materialsListApi = {
  async getMaterials(params) {
    return await instance()
      .get("/material/read/", { params })
      .then((res) => res?.data);
  },

  async getMaterialTypesFilter(params) {
    return await instance()
      .get("/provider_request/material_type/", { params })
      .then((res) => res?.data);
  },

  async getProvidersFilter(params) {
    return await instance()
      .get("/provider_request/provider/", { params })
      .then((res) => res?.data);
  },

  async getProviders() {
    return await instance()
      .get("/provider_request/provider/")
      .then((res) => res?.data);
  },

  async updProvider(body, params) {
    return await instance()
      .post("/handbook/material_provider/upd/", body, { params })
      .then((res) => res?.data);
  },

  async getUnitsList() {
    return await instance()
      .get("/material/unit/")
      .then((res) => res?.data);
  },

  async updProviderPrice(body, params) {
    return await instance()
      .post("/handbook/material_provider/price_upd/", body, { params })
      .then((res) => res?.data);
  },

  async getMaterialsList() {
    return await instance()
      .get("/provider_request/material/")
      .then((res) => res?.data);
  },

  async updMaterial(body, params) {
    return await instance()
      .post("/material/zakup/upd/", body, { params })
      .then((res) => res?.data);
  },

  async getMaterialProvidersList(params) {
    return await instance()
      .get("/handbook/material_provider/read/", { params })
      .then((res) => res?.data);
  },

  async getMaterialProviderPriceList(params) {
    return await instance()
      .get("/handbook/material_provider/price_history/read/", { params })
      .then((res) => res?.data);
  },

  async deleteMaterialProvider(material_provider_id, params) {
    return await instance()
      .delete(`/handbook/material_provider/${material_provider_id}/delete/`, {
        params,
      })
      .then((res) => res?.data);
  },

  async deleteProviderPrice(material_priovider_price_id, params) {
    return await instance()
      .delete(
        `/handbook/material_provider/price/${material_priovider_price_id}/delete/`,
        { params }
      )
      .then((res) => res?.data);
  },

  async deleteMaterial(material_id, params) {
    return await instance()
      .delete(
        `/material/${material_id}/delete/`,
        { params }
      )
      .then((res) => res?.data);
  },

  async getSbsNomenklaturaListForModal(search_text = "", kategoriya = null) {
    return await instance()
      .post("/material/sbs_nomenklatura/", { search_text, kategoriya })
      .then((res) => res?.data);
  },
  async getSbsNomenklaturaKategoriya() {
    return await instance()
      .get("/material/sbs_nomenklatura_kategoriya/")
      .then((res) => res?.data);
  },

  async getRequiredTypesFilter() {
    return await instance()
      .get("/material/required_types/")
      .then((res) => res?.data);
  },
};